
// alerts
export const ALERT_CREATED = 'ALERT_CREATED';

export function AlertCreated(alertObj) {
  return {
    type: ALERT_CREATED,
    alert: alertObj
  }
}

// blog posts 
export const BLOGPOST_CREATED = 'BLOGPOST_CREATED';
export const BLOGPOSTS_LOADED = 'BLOGPOSTS_LOADED';
export const BLOGPOST_UPDATED = 'BLOGPOST_UPDATED';

export function BlogPostCreated(obj) {
  return {
    type: BLOGPOST_CREATED,
    blogPost: obj
  }
}

export function BlogPostsLoaded(objs) {
  return {
    type: BLOGPOSTS_LOADED,
    blogPosts: objs
  }
}

export function BlogPostUpdated(obj) {
  return {
    type: BLOGPOST_UPDATED,
    blogPost: obj
  }
}

// classes
export const CLASS_CREATED = 'CLASS_CREATED';
export const CLASSES_LOADED = 'CLASS_LOADED';
export const CLASS_UPDATED = 'CLASS_UPDATED';

export function ClassCreated(obj) {
  return {
    type: CLASS_CREATED,
    class: obj
  }
}

export function ClassUpdated(obj) {
  return {
    type: CLASS_UPDATED,
    class: obj
  }
}

export function ClassesLoaded(classes) {
  return {
    type: CLASSES_LOADED,
    classes: classes
  }
}

// courses
export const COURSE_CREATED = 'COURSE_CREATED';
export const COURSES_LOADED = 'COURSE_LOADED';
export const COURSE_UPDATED = 'COURSE_UPDATED';

export function CourseCreated(course) {
  return {
    type: COURSE_CREATED,
    course: course
  }
}

export function CoursesLoaded(courses) {
  return {
    type: COURSES_LOADED,
    courses: courses
  }
}

// events
export const EVENT_CREATED = 'EVENT_CREATED';
export function EventCreated(eventObj) {
  return {
    type: EVENT_CREATED,
    alert: eventObj
  }
}

// lessons
export const LESSON_CREATED = 'LESSON_CREATED';
export const LESSONS_LOADED = 'LESSON_LOADED';
export const LESSON_UPDATED = 'LESSON_UPDATED';

export function LessonCreated(lesson) {
  return {
    type: LESSON_CREATED,
    lesson: lesson
  }
}

export function LessonsLoaded(lessons) {
  return {
    type: LESSONS_LOADED,
    lessons: lessons
  }
}


// locations
export const LOCATION_CREATED = 'LOCATION_CREATED';
export const LOCATIONS_LOADED = 'LOCATIONS_LOADED';
export const LOCATION_UPDATED = 'LOCATION_UPDATED';

export function LocationCreated(location) {
  return {
    type: LOCATION_CREATED,
    location: location
  }
}

export function LocationsLoaded(locations) {
  return {
    type: LOCATIONS_LOADED,
    locations: locations
  }
}

export function LocationUpdated(location) {
  return {
    type: LOCATION_UPDATED,
    location: location
  }
}

// org
export const ORG_LOADED = 'ORG_LOADED';
export const ORG_UPDATED = 'ORG_UPDATED';

export function OrgLoaded(orgObj) {
  return {
    type: ORG_LOADED,
    org: orgObj
  }
}

export function OrgUpdated(orgObj) {
  return {
    type: ORG_UPDATED,
    org: orgObj
  }
}

// products 
export const PRODUCT_CREATED = 'PRODUCT_CREATED';
export const PRODUCTS_LOADED = 'PRODUCTS_LOADED';
export const PRODUCT_UPDATED = 'PRODUCT_UPDATED';

export function ProductCreated(product) {
  return {
    type: PRODUCT_CREATED,
    product: product
  }
}

export function ProductsLoaded(products) {
  return {
    type: PRODUCTS_LOADED,
    products: products
  }
}

export function ProductUpdated(product) {
  return {
    type: PRODUCT_UPDATED,
    product: product
  }
}

// schools 
export const SCHOOL_CREATED = 'SCHOOL_CREATED';
export const SCHOOLS_LOADED = 'SCHOOLS_LOADED';
export const SCHOOL_UPDATED = 'SCHOOL_UPDATED';

export function SchoolCreated(obj) {
  return {
    type: SCHOOL_CREATED,
    school: obj
  }
}

export function SchoolsLoaded(objs) {
  return {
    type: SCHOOLS_LOADED,
    schools: objs
  }
}

export function SchoolUpdated(obj) {
  return {
    type: SCHOOL_UPDATED,
    school: obj
  }
}

// students
export const STUDENT_CREATED = 'STUDENT_CREATED';
export const STUDENTS_LOADED = 'STUDENTS_LOADED';
export const STUDENT_UPDATED = 'STUDENT_UPDATED';

export function StudentCreated(student) {
  return {
    type: STUDENT_CREATED,
    student: student
  }
}

export function StudentsLoaded(students) {
  return {
    type: STUDENTS_LOADED,
    students: students
  }
}

export function StudentUpdated(student) {
  return {
    type: STUDENT_UPDATED,
    student: student
  }
}


// teachers
export const TEACHER_CREATED = 'TEACHER_CREATED';
export const TEACHERS_LOADED = 'TEACHERS_LOADED';
export const TEACHER_UPDATED = 'TEACHER_UPDATED';

export function TeacherCreated(obj) {
  return {
    type: TEACHER_CREATED,
    teacher: obj
  }
}

export function TeachersLoaded(objs) {
  return {
    type: TEACHERS_LOADED,
    teachers: objs
  }
}

export function TeacherUpdated(obj) {
  return {
    type: TEACHER_UPDATED,
    teacher: obj
  }
}

// user
export const USER_LOGGEDIN = 'USER_LOGGEDIN';
export const USER_LOGGEDOUT = 'USER_LOGGEDOUT';

export function UserLoggedIn(userObj) {
  return {
    type: USER_LOGGEDIN,
    user: userObj
  }
}

export function UserLoggedOut() {
  return {
    type: USER_LOGGEDOUT,
    user: null
  }
}


// videos 
export const VIDEO_CREATED = 'VIDEO_CREATED';
export const VIDEOS_LOADED = 'VIDEOS_LOADED';
export const VIDEO_UPDATED = 'VIDEO_UPDATED';

export function VideoCreated(video) {
  return {
    type: VIDEO_CREATED,
    video: video
  }
}

export function VideosLoaded(videos) {
  return {
    type: VIDEOS_LOADED,
    videos: videos
  }
}

export function VideoUpdated(video) {
  return {
    type: VIDEO_UPDATED,
    video: video
  }
}

// search
export const SEARCH_USERS = 'SEARCH_USERS';
export const SEARCH_RESULTS = 'SEARCH_RESULTS';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';

export function SearchUsers(query) {
  return {
    type: SEARCH_USERS,
    query: query
  }
}

export function SearchResults(results) {
  return {
    type: SEARCH_RESULTS,
    results: results
  }
}

export function ClearSearch() {
  return {
    type: CLEAR_SEARCH
  }
}




// WEBPACK FOOTER //
// ./src/redux/actions.js